import './lib/sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { RolloutProvider } from '@halo-compliance/rollout-client'
import { router } from './router'
import { rollout } from './lib/rollout'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fontsource/arvo/400.css'
import '@fontsource/arvo/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import './styles/marketing.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RolloutProvider clientKey={rollout.statsigClientKey} environment={rollout.tier}>
      <RouterProvider router={router} />
    </RolloutProvider>
  </StrictMode>,
)
